<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :confirm="askConfirm"
                    :subTitle="$t('urbanStudy.create.subTitle')"
                    :title="$t('Add') + ' ' + $t('a.e')  + ' ' +  $t('urbanStudy')" route-back="UrbanStudyIndex"/>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <b-form v-unsave-detector @submit.stop.prevent="onSubmit">
              <div class="row">
                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.name.invalidFeedback"
                    :label="$t('urbanStudy.Name.of')"
                    :state="form.name.state"
                    class="medium-label mb-4"
                    label-for="name-input">
                    <b-form-input
                      id="name-input"
                      v-model="form.name.value"
                      :state="form.name.state"
                      maxlength="250"
                      required
                      type="text"
                      v-on:change="removeInvalidFeedback('name'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.viability.invalidFeedback"
                    :label="$t('urbanStudy.isViable')"
                    :state="form.viability.state"
                    class="medium-label mb-4"
                    label-for="viability-input">
                    <b-form-select
                      id="viability-input"
                      v-model="form.viability.value"
                      :state="form.viability.state"
                      required
                      v-on:change="removeInvalidFeedback('viability'); askConfirm=true; ">
                      <option v-for="option in urbanStudyViabilities" :value="option.value">
                        {{ $t(option.text) }}
                      </option>
                    </b-form-select>
                  </b-form-group>
                </div>

                <div class="col-md-12">
                  <b-form-group
                    :invalid-feedback="form.generalInfo.invalidFeedback"
                    :label="$t('urbanStudy.GeneralInfo')"
                    :state="form.generalInfo.state"
                    class="medium-label mb-4"
                    label-for="generalInfo-input">
                    <b-form-textarea
                      id="generalInfo-input"
                      v-model="form.generalInfo.value"
                      :state="form.generalInfo.state"
                      maxlength="1000"
                      type="text"
                      v-on:change="removeInvalidFeedback('generalInfo'); askConfirm=true;">
                    </b-form-textarea>
                  </b-form-group>

                  <data-source-info-multi-tabs-edit-field
                    :tabInfoByDataSourceValues="form.tabInfoByDataSourceValues"
                    @oneValueChanged="updateTabInfoByDataSourceValues">
                  </data-source-info-multi-tabs-edit-field>
                </div>
              </div>

              <div class="d-flex justify-content-end">
                <b-button id="register-btn" class="mr-3" type="submit" variant="outline-primary">
                  {{ $t('Register.object') }}
                </b-button>
                <b-button id="validate-btn" type="submit" variant="primary">{{ $t('Validate') }}</b-button>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>
    </b-container>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import DataSourceInfoMultiTabsEditField from './DataSourceInfoMultiTabsEditField'

export default {

  name: 'UrbanStudyCreate',

  components: {
    BackArrow,
    DataSourceInfoMultiTabsEditField,
  },

  data() {
    return {
      urbanStudyId: this.$route.params.urbanStudyId,
      urbanStudyViabilities: [],
      askConfirm: false,
      form: {
        name:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        viability:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        generalInfo:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        tabInfoByDataSourceValues: {}
      }
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {

    async fetchData() {
      await this.fetchUrbanStudyViabilities()
    },

    async fetchUrbanStudyViabilities() {
      await api
        .get(`/urbanStudy/getUrbanStudyViabilities`)
        .then(response => {
          this.urbanStudyViabilities = response.data
        })
    },

    onSubmit(event) {
      let isOnlyRegister = (event.submitter.id === 'register-btn')

      let data = new FormData()
      data.append('name', this.form.name.value)
      data.append('viability', this.form.viability.value)
      if (this.form.generalInfo.value) {
        data.append('generalInfo', this.form.generalInfo.value)
      }

      let tabInfoByDataSourceValuesFormatted = []
      for (const [dataSourceValue, dataSourceInfos] of Object.entries(this.form.tabInfoByDataSourceValues)) {
        let comment = dataSourceInfos.comment.value
        if (comment != null) {
          tabInfoByDataSourceValuesFormatted.push({
            'dataSource': dataSourceValue,
            'comment': dataSourceInfos.comment.value
          })
        }
      }
      data.append('dataSourceInfos', JSON.stringify(tabInfoByDataSourceValuesFormatted))

      api({
        method: 'POST',
        url: `urbanStudy`,
        data: data
      })
        .then(response => {
          //cas particulier: btn register
          if (isOnlyRegister) {
            this.$router.push({
              name: 'UrbanStudyEdit',
              params: {
                urbanStudyId: response.data.id
              }
            }, () => {
              this.$nextTick(() => {
                this.successToast(this.form.name.value, true)
              })
            })
            return
          }

          this.$router.push({
            name: 'UrbanStudyIndex'
          }, () => {
            this.$nextTick(() => {
              this.successToast(this.form.name.value, false)
            })
          })

        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'UrbanStudyIndex',
              params: {
                message: error.response.data.message
              }
            })
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },

    removeInvalidFeedback(field) {
      this.form[field]['state'] = null
    },

    updateTabInfoByDataSourceValues(data) {
      this.form.tabInfoByDataSourceValues = data
    },

    successToast(urbanStudyName, isOnlyRegister) {
      this.$bvToast.toast(this.$i18n.t('UrbanStudy') + ' "' + urbanStudyName + '" ' + this.$i18n.t(isOnlyRegister ? 'f.registered.object' : 'f.added'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/urbanStudy/UrbanStudyCreate.vue